import React, { useState, useEffect } from "react";
import axios from "axios";
import MovieCard from "./MovieCard.js";

const Search = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios
      .get(
        "https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=864351c4983b669ad95578b475142944&language=en-US&page=1"
      )
      .then((res) => {
        setMovies(res.data.results);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    axios
      .get(
        `https://api.themoviedb.org/3/search/movie?&api_key=864351c4983b669ad95578b475142944&language=en-US&query=${searchTerm}`
      )
      .then((res) => {
        setMovies(res.data.results);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        <input
          className="search-input"
          type="search"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleChange}
        />
      </form>
      <div className="row row-cols-1  row-cols-sm-2 row-cols-md-3 row-cols-lg-4 NewRel ">
        {movies.map((movie) => (
          <MovieCard movie={movie}/>
        ))}
      </div>
    </div>
  );
};

export default Search;
